import React from "react";
import { Apple, Droplets, Sparkles, ArrowRight } from "lucide-react";

const steps = [
    {
        n: "01",
        icon: Apple,
        title: "Escolhe o sabor",
        text: "8 polpas de fruta congelada à tua espera. Manga, Maracujá, Frutos Vermelhos e mais.",
        color: "bg-brand-orange-soft",
        accent: "text-brand-orange",
    },
    {
        n: "02",
        icon: Droplets,
        title: "Adicionamos água",
        text: "A medida certa, na temperatura ideal. Sem cadeia de frio, sem complicação.",
        color: "bg-brand-green-soft",
        accent: "text-brand-green",
    },
    {
        n: "03",
        icon: Sparkles,
        title: "Misturamos na hora",
        text: "Sumo natural, fresco, consistente. Pronto em segundos. Servido com sorriso.",
        color: "bg-brand-pink",
        accent: "text-[#CFA059]",
    },
];

export const HowItWorks = () => {
    return (
        <section
            id="como-funciona"
            data-testid="how-it-works"
            className="py-20 md:py-28 relative"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl">
                    <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">
                        Como funciona
                    </span>
                    <h2 className="mt-3 font-display font-medium text-4xl md:text-5xl text-brand-ink leading-tight">
                        Três passos. Trinta segundos.{" "}
                        <span className="text-brand-green">Sumo natural.</span>
                    </h2>
                </div>

                <div className="mt-14 grid md:grid-cols-3 gap-6 md:gap-8">
                    {steps.map((s, i) => (
                        <div
                            key={s.n}
                            data-testid={`step-${s.n}`}
                            className={`relative rounded-2xl ${s.color} p-8 md:p-10 transition-all hover:-translate-y-2 duration-300`}
                        >
                            <div className="flex items-start justify-between">
                                <div
                                    className={`font-display font-medium text-6xl ${s.accent} opacity-80`}
                                >
                                    {s.n}
                                </div>
                                <div className="h-14 w-14 rounded-2xl bg-white flex items-center justify-center shadow-soft">
                                    <s.icon className={`h-6 w-6 ${s.accent}`} />
                                </div>
                            </div>
                            <h3 className="mt-8 font-display font-medium text-2xl text-brand-ink">
                                {s.title}
                            </h3>
                            <p className="mt-3 text-brand-ink-soft leading-relaxed">{s.text}</p>
                            {i < steps.length - 1 && (
                                <ArrowRight className="hidden md:block absolute -right-5 top-1/2 -translate-y-1/2 h-8 w-8 text-brand-ink/30" />
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
